export enum Sword {
  None,
  Wooden,
  Master,
  Tempered,
  Golden
}
